<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_reservation") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-select-input
            col="6"
            :optionsList="patients"
            :placeholder="$t('PLACEHOLDERS.patient')"
            v-model="data.patient"
            required
          />
          <base-select-input
            col="6"
            :optionsList="branches"
            :placeholder="$t('PLACEHOLDERS.branch')"
            v-model="data.branch"
            required
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.age')"
            v-model.trim="data.age"
            required
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.order_price')"
            v-model.trim="data.cost"
            required
          />
          <base-select-input
            col="6"
            :optionsList="reservationTypes"
            :placeholder="$t('PLACEHOLDERS.reservation_type')"
            v-model="data.reservation_type"
            required
          />
          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.date')"
            v-model="data.date"
            required
          />
          <base-input
            col="6"
            type="time"
            :placeholder="$t('PLACEHOLDERS.time')"
            v-model.trim="data.time"
            required
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateReservation",

  data() {
    return {
      isWaitingRequest: false,
      patients: [],
      branches: [],
      reservationTypes: [
        { id: "consultation", name: "استشارة" },
        { id: "checkup", name: "كشف" },
      ],
      data: {
        patient: null,
        branch: null,
        age: null,
        cost: null,
        reservation_type: null,
        date: null,
        time: null,
      },
    };
  },

  methods: {
    async getPatients() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "patients",
          params: {
            page: 0,
            limit: 0,
          },
        });
        const payload = res.data?.data || {};
        this.patients = (payload.data || []).map((item) => ({
          id: item.id,
          name: item.name,
        }));
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to load patients"
        );
      }
    },
    async getBranches() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "branches",
          params: {
            page: 0,
            limit: 0,
          },
        });
        const payload = res.data?.data || {};
        this.branches = (payload.data || []).map((item) => ({
          id: item.id,
          name: item.name,
        }));
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to load branches"
        );
      }
    },
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("patient_id", this.data.patient?.id || "");
      REQUEST_DATA.append("branch_id", this.data.branch?.id || "");
      REQUEST_DATA.append("age", this.data.age || "");
      REQUEST_DATA.append("cost", this.data.cost || "");
      REQUEST_DATA.append(
        "reservation_type",
        this.data.reservation_type?.id || ""
      );
      REQUEST_DATA.append("date", this.data.date || "");
      REQUEST_DATA.append("time", this.data.time || "");

      try {
        await this.$axios({
          method: "POST",
          url: "reservations",
          data: REQUEST_DATA,
        });
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/reservations/all" });
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to add reservation"
        );
      } finally {
        this.isWaitingRequest = false;
      }
    },
  },

  created() {
    this.getPatients();
    this.getBranches();
  },
};
</script>
